import { TransactionDetailReportResponseEntity } from "features/generals/domain/entities/transactionReports/TransactionDetailReportResponseEntity";
import { TransactionReportResponseEntity } from "features/generals/domain/entities/transactionReports/TransactionReportResponseEntity";
import { CurrencyEnum } from "utils/enums/CurrencyEnum";

export class GeneralCurrencyMappers {
  private constructor() {}

  static getCurrencyEnum = (currencyCode?: string) =>
    String(currencyCode || "VND").toUpperCase() === "USD"
      ? CurrencyEnum.$
      : CurrencyEnum.VND;

  static getDisplayStatByCurrency = <T>(
    data: Array<{ currency?: string; displayStat?: Array<T> }> = [],
    selectedCurrency = "VND"
  ): Array<T> => {
    const matchedItem = data.find(
      (item) =>
        String(item?.currency || "").toUpperCase() ===
        String(selectedCurrency || "VND").toUpperCase()
    );

    return matchedItem?.displayStat || [];
  };

  static extractCurrencies = (
    data:
      | Array<{ currency?: string }>
      | Array<TransactionReportResponseEntity>
      | Array<TransactionDetailReportResponseEntity>
      | undefined
  ) => {
    return Array.from(
      new Set(
        (data || [])
          .map((item) =>
            String(item?.currency || "")
              .toUpperCase()
              .trim()
          )
          .filter(Boolean)
      )
    );
  };
}
